/**
 * The keys used for local storage.
 *
 * @enum {string}
 */
export const StorageKeyName = {
    AMPLITUDE_SESSION_ID: 'amp_session_id',
    MERCH_TOOL: 'merch_tool',
    MERCHTOOL_CURATE_COLLECTIONS: 'merchtool_curate_collections',
    MERCHTOOL_SPOTLIGHT_TYPES: 'merchtool_spotlight_types',
    SELECTED_PERMISSIONS_GROUPS: 'selected_permissions_groups',
    STYLE_GUIDE_NAV: 'style_guide_nav',
};

const LocalStorage = {
    /**
     * @returns {boolean}
     */
    isEnabled() {
        return !!window.localStorage;
    },

    /**
     * Gets an item from local storage
     * @param {string} key
     * @returns {string|undefined}
     */
    getItem(key) {
        return LocalStorage.isEnabled() ? localStorage.getItem(key) : undefined;
    },

    /**
     * Gets a JSON item from local storage and parses it into an Object
     * @param key
     * @returns {Object}
     */
    getObjectItem(key) {
        const item = LocalStorage.getItem(key);
        if (item) {
            return JSON.parse(item);
        }

        return {};
    },

    /**
     * Removes an item from local storage
     * @param {string} key
     */
    removeItem(key) {
        if (LocalStorage.isEnabled()) {
            localStorage.removeItem(key);
        }
    },

    /**
     * Sets an item in local storage
     *
     * @param {string} key
     * @param {string} data
     */
    setItem(key, data) {
        if (LocalStorage.isEnabled()) {
            localStorage.setItem(key, data);
        }
    },

    /**
     * Sets an object in local storage by first converting it to a string
     *
     * @param {string} key
     * @param {Object} data
     */
    setObjectItem(key, data) {
        LocalStorage.setItem(key, JSON.stringify(data));
    },
};

export default LocalStorage;
